import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  noRecordsMessage: {
    fontFamily: 'Roboto',
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: '14px',
    textAlign: 'center',
    color: '#3C419A',
    marginTop: '10px'
  },
  noRecordsIcon: {
    width: '25px',
    height: '25px',
  },
  iconOnLeft: {
    '& svg': {
      display: 'inline-block',
      position: 'relative',
      top: '8px',
      marginRight: '10px',
    },
    '& div': {
      display: 'inline-block',      
    },
  },
}));
